<script>
import Layout from "../../../layouts/main";
import ExportButton from "@/components/export-button";
import axios from "@/axios";
import { formatCurrency, getDateWithFormat } from "@/utils";
import moment from "moment";

export default {
  components: {
    Layout,
    "export-button": ExportButton
  },
  data() {
    return {
      datosBoleta: this.$store.getters["docs/boletaFactura"],
      rutEmpresa: this.$store.getters["rutEmpresa/cuentaSeleccionada"].value,
      numeroDocumento: parseInt(this.$store.getters["hideValue/detailId"]),
      numeroContrato: this.$store.getters["docs/boletaFactura"]['contrato'],
      period: this.$store.getters["hideValue/filter"]['period'],
      fechaEmision: '',
      tipo: '',
      fields: [
        {
          key: "estadoDePago",
          label: "ID estado pago",
          sortable: false,
        },
        {
          key: "anio",
          label: "Año",
          sortable: false,
        },
        {
          key: "mes",
          label: "Fecha de periodo",
          sortable: false,
        },
        {
          key: "totalFlota",
          label: "Monto de flota",
          sortable: false,
        },
        {
          key: "totalTelevia",
          label: "Monto de TAG",
          sortable: false,
        },
        {
          key: "totalMultas",
          label: "Monto de infracciones de transito",
          sortable: false,
        },
        {
          key: "totalGastosReembolsables",
          label: "Total de Gastos Reembolsables",
          sortable: false,
        },
        {
          key: "descargas",
          label: "Descargas",
          sortable: false,
        }
      ],
      tableData: [],
      isBusy: true,
      isBusy2: 0,
      isBusy3: 0,
      isBusy4: 0
    };
  },
  beforeMount() {
    this.getEstadoPagoLOP();
  },
  methods:{
    getCurrency(inport) {
      return formatCurrency(inport);
    },
    getEstadoPagoLOP() {
      this.isBusy = true;
      axios
        .get(`/GetEstadoPagoLop?` + 
          `rutEmpresa=${this.rutEmpresa}&` + 
          `numeroContrato=${this.numeroContrato}&` + 
          `FechaDesde=${moment(this.period[0]).format("YYYY-MM-DD")}&` + 
          `FechaHasta=${moment(this.period[1]).format("YYYY-MM-DD")}`)
        .then((docs) => {
          this.tableData = docs.data.datos
          this.fechaEmision = this.getDate(this.tableData.fechaEmision)
          this.isBusy = false;
        })
        .catch(() => {
          this.$bvToast.toast(
            this.$t("lease.request.error.message").toString(),
            {
              title: this.$t("lease.request.error.nonFound").toString(),
              variant: "danger",
              solid: true,
            }
          );
          this.isBusy = false;
        });      
    },
    downloadDocumento(row, tipo){
      let rut = row.item.rut;
      let contrato = row.item.contrato;
      let ep = row.item.estadoDePago;
      let mes = row.item.mes;
      let anio = row.item.anio;
      this.isBusy2 = ep;
      this.tipo = tipo;
      let url = `/GetPDF${tipo}Lop`;
      axios.get(`${url}?RutEmpresa=${rut}&NumeroContrato=${contrato}&NumeroEP=${ep}&Mes=${mes}&Anio=${anio}`)
      .then(documento => {
        this.isBusy2 = 0;
        this.tipo = '';
        if (documento.data.pdf) {
            const blob = this.b64toBlob(
              documento.data.pdf,
              "application/pdf"
            );
            let fileURL = window.URL.createObjectURL(blob);
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              `${tipo}_${ep}.pdf`
            );
            document.body.appendChild(fileLink);

            fileLink.click();
          } else {
            this.$bvToast.toast(this.$t('lease.pdf.error.nonFound').toString(), {
                title: this.$t('lease.pdf.error.download').toString(),
                variant: 'danger',
                solid: true
            });
        }
      })
      .catch(() => {
            this.$bvToast.toast(this.$t('lease.pdf.error.nonFound').toString(), {
              title: this.$t('lease.pdf.error.download').toString(),
              variant: 'danger',
              solid: true
            })
          this.isBusy2 = 0;
          this.tipo = '';
          }
      );
    },
    downloadPDFEP(row) {
      this.isBusy3 = row.item.estadoDePago
      axios.get(`/PDFEstadoPagoLop/${row.item.rut}/${row.item.estadoDePago}`)
        .then(documento => {
          if (documento.data.pdf) {
            const blob = this.b64toBlob(
                documento.data.pdf,
                "application/pdf"
            );
            let fileURL = window.URL.createObjectURL(blob);
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute(
                "download",
                `${row.item.estadoDePago}.pdf`
            );
            document.body.appendChild(fileLink);

            fileLink.click();
            this.isBusy3 = false
          } else {
            this.$bvToast.toast(this.$t('lease.pdf.error.nonFound').toString(), {
              title: this.$t('lease.pdf.error.download').toString(),
              variant: 'danger',
              solid: true
            });
            this.isBusy3 = false
          }
        })
      .catch(() => {
        this.$bvToast.toast(this.$t('lease.pdf.error.nonFound').toString(), {
          title: this.$t('lease.pdf.error.download').toString(),
          variant: 'danger',
          solid: true
        });
        this.isBusy3 = false
      })
    },
    downloadExcelEP(row) {
      this.isBusy4 = row.item.estadoDePago
      axios.get(`/ExcelEstadoPagoLop/${row.item.rut}/${row.item.estadoDePago}`)
        .then(documento => {
          if (documento.data.excel) {
            const blob = this.b64toBlob(
                documento.data.excel,
                "application/ms-excel"
            );
            let fileURL = window.URL.createObjectURL(blob);
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute(
                "download",
                `${row.item.estadoDePago}.xls`
            );
            document.body.appendChild(fileLink);

            fileLink.click();
            this.isBusy4 = 0
          } else {
            this.$bvToast.toast(this.$t('lease.excel.error.nonFound').toString(), {
              title: this.$t('lease.excel.error.download').toString(),
              variant: 'danger',
              solid: true
            });
            this.isBusy4 = 0
          }
        })
      .catch(() => {
        this.$bvToast.toast(this.$t('lease.excel.error.nonFound').toString(), {
          title: this.$t('lease.excel.error.download').toString(),
          variant: 'danger',
          solid: true
        });
        this.isBusy4 = 0
      })
    },
    back() {
      history.back();
    },
    getDate(date) {
      return getDateWithFormat(date);
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  }
};
</script>
<template>
  <Layout>
    <div classs="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center" class="mb-3">
              <h4 class="card-tittle">Detalle Boleta/Factura y Estados de Pago</h4>
              <div class="justify-content-end">
                <b-button variant="dark" @click="back()">Volver </b-button>
                <export-button :data="tableData" class="spacingButton" fileName="documentos" />
              </div>
            </b-row>
            <!-- <b-row>
              <b-col sm="12" md="6" lg="3">
                <b-form-group
                    id="input-group-1"
                    label="Boleta/Factura"
                    label-for="formrow-inputState"
                >
                  <b-form-input
                      id="formrow-name-input"
                      v-model="datosBoleta.numeroDocumento"
                      :disabled="true"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Tipo" label-for="formrow-name-input">
                  <b-form-input
                      type="text"
                      id="formrow-name-input2"
                      v-model="datosBoleta.descripcionDocumento"
                      :disabled="true"
                  >
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Saldo" label-for="formrow-name-input2">
                  <b-form-input
                      type="number"
                      id="formrow-name-input3"
                      v-model="datosBoleta.saldoDocumento"
                      :disabled="true"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="3" offset-lg="3">
                <b-form-group label="Fecha emisión" label-for="formrow-name-input3">
                  <b-form-input
                      type="text"
                      id="formrow-name-input"
                      v-model="fechaEmision"
                      :disabled="true"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row> -->
            <div class="container">
              <b-table 
              :items="tableData" 
              :fields="fields"
              responsive="sm" 
              :busy="isBusy"
              class="text-center"
              >

                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #cell(totalFlota)="row">
                  <b-spinner v-if="isBusy2 === row.item.estadoDePago && tipo === 'flota'" small></b-spinner>
                  <a v-else-if="row.value > 0" class="links" @click="downloadDocumento(row, 'flota')">
                    {{ "$ " + getCurrency(row.value) }}
                  </a>
                  <div v-else>
                    {{ "$ " + getCurrency(row.value) }}
                  </div>
                </template>
                <template #cell(totalTelevia)="row">
                  <b-spinner v-if="isBusy2 === row.item.estadoDePago && tipo === 'Tag'" small></b-spinner>
                  <a v-else-if="row.value > 0" class="links" @click="downloadDocumento(row, 'Tag')">
                    {{ "$ " + getCurrency(row.value) }}
                  </a>
                  <div v-else>
                    {{ "$ " + getCurrency(row.value) }}
                  </div>
                </template>
                <template #cell(totalMultas)="row">
                  <b-spinner v-if="isBusy2 === row.item.estadoDePago && tipo === 'Multas'" small></b-spinner>
                  <a v-else-if="row.value > 0" class="links" @click="downloadDocumento(row, 'Multas')">
                    {{ "$ " + getCurrency(row.value) }}
                  </a>
                  <div v-else>
                    {{ "$ " + getCurrency(row.value) }}
                  </div>
                </template>
                <template #cell(descargas)="row">
                  <div class="justify-content-end">
                    <b-button variant="danger" @click="downloadPDFEP(row)">
                      <b-spinner v-if="isBusy3 === row.item.estadoDePago" small class="align-middle"></b-spinner>
                      <div v-else>Descargar PDF</div>
                    </b-button>
                    <b-button variant="danger" class="spacingButton" @click="downloadExcelEP(row)">
                      <b-spinner v-if="isBusy4 === row.item.estadoDePago" small class="align-middle"></b-spinner>
                      <div v-else>Descargar EXCEL</div>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.spacingButton{
  margin-left: 1rem;
}
</style>
